import React, { useMemo, useState } from 'react';
import { Box, Text, Stack, Flex, Button, Heading } from '@chakra-ui/react';
import { CaretDown, CaretUp } from '@phosphor-icons/react';
import GroundingSources from './GroundingSources';
import CitationDisplay from './CitationDisplay';

const SiteGroundingInfo = ({ description, citations, groundingArticles, showTitle = false, ...props }) => {
  const [showSources, setShowSources] = useState(false);
  
  // Extract the actual description text if it's an object with value property
  const actualDescription = useMemo(() => {
    if (typeof description === 'object' && description !== null && 'value' in description) {
      return description.value;
    }
    return description;
  }, [description]);


  return (
    <Box>
      <CitationDisplay text={actualDescription} citations={citations} />
      
      {groundingArticles && groundingArticles.length > 0 && (
        <Box className="css-1a4nlxj">
          <Stack className="chakra-stack css-ktfa8s">
            <Flex justify="space-between" align="center" className="chakra-stack css-1igwmid">
              <Heading as="h4" className="chakra-heading css-2hum8n">Sources</Heading>
              <Button 
                size="sm" 
                variant="ghost" 
                onClick={() => setShowSources(!showSources)}
                rightIcon={showSources ? <CaretUp /> : <CaretDown />}
                ml={2}
              >
                {showSources ? 'Hide' : 'Show'}
              </Button>
            </Flex>
            
            {showSources && <GroundingSources articles={groundingArticles} />}
          </Stack>
        </Box>
      )}
    </Box>
  );
};
export default SiteGroundingInfo;
